import RejectedTemplate from './success';

export {RejectedTemplate};
